import { Utility } from "../utility.js"
import { Outdoor } from "./outdoor.js"

export class LanternWishes extends Outdoor {
    static info = {
        key: "lantern-wishes",
        name: "Help your friends release their lantern wishes",
        description: "The lantern festival is the 15th and final day of the celebration. Traditionally, families or friends decorate lanterns together with drawings and their wishes for the new year before releasing them together into the sky. Bring lanterns to your friends so that they can make a wish!",
        logo: { x: 970, y: 520 },
        won: false
    }
    constructor(key, level){
        super(key, level, { holder: false, bobInRed: true })
        this._decorHanger = [
            {
                "name": "gnl-lantern-display-completed-1",
                "positions": {"left": 1643, "top": 671},
            },
            {
                "name": "gnl-lantern-display-completed-2",
                "positions": {"left": 799, "top": 1469},
            },
            {
                "name": "gnl-lantern-display-completed-3",
                "positions": {"left": 2716, "top": 1472},
            },
            {
                "name": "gnl-lantern-display-completed-4",
                "positions": {"left": 1895, "top": 2294},
            }
        ]
        this._staticLantern = [
            {
                "name": "hpl-flying-lantern1",
                "positions": {"left": 1311, "top": 739},
            },
            {
                "name": "hpl-flying-lantern2",
                "positions": {"left": 1730, "top": 1866},
            },
            {
                "name": "hpl-flying-lantern3",
                "positions": {"left": 2964, "top": 1836},
            }
        ]
        this._normalNeighbor = [
            {
                "name": "hpl-kid-01",
                "positions": {"left": 1655, "top": 1319},
                "wish": "Thank you! I wish for laughter and joy for my family this year.",
                "done": false
            },
            {
                "name": "hpl-adult",
                "positions": {"left": 1570, "top": 2260},
                "wish": "Thank you! I wish for a happy and healthy year for my family. ",
                "done": false
            },
            {
                "name": "hpl-kid-02",
                "positions": {"left": 3495, "top": 1575},
                "wish": "Thanks! I wish for a fun school year!",
                "done": false
            }
        ]
        this._happyNeighbor = [
            {
                "name": "hpl-kid-01-happy",
                "positions": {"left": 1645, "top": 1319},
            },
            {
                "name": "hpl-adult-happy",
                "positions": {"left": 1630, "top": 2260},
            },
            {
                "name": "hpl-kid-02-happy",
                "positions": {"left": 3495, "top": 1575},
            }
        ]
        this._flyingLanterns = null
        this._withLantern = false
        this._happyBob = false
        this._neighbourGroup = null
        this._happyHomie = null
        this._homieBubble = {container: null, started: null}
        this._sumOfStars = null
    }
    preload(){
        super.preload()
        this._decorHanger.forEach(d => this.load.image(d.name, `assets/lantern-wishes/decor-hanger/${d.name}.png`))
        this._staticLantern.forEach(l => this.load.image(l.name, `assets/lantern-wishes/flying-lanterns/${l.name}.png`))
        this._normalNeighbor.forEach(l => this.load.image(l.name, `assets/lantern-wishes/neighbours/neighbours-normal/${l.name}.png`))
        this._happyNeighbor.forEach(l => this.load.image(l.name, `assets/lantern-wishes/neighbours/neighbours-happy/${l.name}.png`))

        this.load.spritesheet("lantern", "assets/lantern-wishes/hpl-sprite-lantern.png", {
            frameWidth: 111,
            frameHeight: 1000
        });
    }
    create(){
        super.create()
        this.anims.create({
            key: "left-red-with-lantern",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 12, end: 15}),
            frameRate: 10,
            repeat: 20
        })
        this.anims.create({
            key: "right-red-with-lantern",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 18, end: 21}),
            frameRate: 10,
            repeat: 20
        })
        this.anims.create({
            key: "turn-right-red-with-lantern",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 17, end: 17}),
            frameRate: 20,
        })
        this.anims.create({
            key: "turn-left-red-with-lantern",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 16, end: 16}),
            frameRate: 20,
        })
        this.anims.create({
            key: "happy-bob-right",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 11, end: 11}),
            frameRate: 20,
        })
        this.anims.create({
            key: "happy-bob-left",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 10, end: 10}),
            frameRate: 20,
        })
        this.anims.create({
            key: "flying-lantern",
            frames: this.anims.generateFrameNumbers("lantern", {start: 0, end: 5}),
            frameRate: 2,
            repeat: 0,
            hideOnComplete: true
        })
        let staticDecorHanger = this.physics.add.staticGroup()
        this._decorHanger.forEach(a => {
                let so = staticDecorHanger.create(a.positions.left, a.positions.top, a.name).setOrigin(0, 0).refreshBody();
                so.setSize(so.body.width, so.body.height - 155, false)
            })
            this._flyingLanterns = this.physics.add.staticGroup()
            this._staticLantern.forEach(l => {
                let so = this._flyingLanterns.create(l.positions.left, l.positions.top, l.name).setOrigin(0, 0).refreshBody();
                so.setSize(so.body.width, so.body.height - 155, false)
            })
            this._neighbourGroup = this.physics.add.staticGroup()
            this._normalNeighbor.forEach(a => {
                this._neighbourGroup.create(a.positions.left, a.positions.top, a.name).setOrigin(0, 0).refreshBody();
            })
            this._happyHomie = this.physics.add.staticGroup()
            this._happyNeighbor.forEach(a => {
                this._happyHomie.create(a.positions.left, a.positions.top, a.name).setOrigin(0, 0).refreshBody().setVisible(false)
            })
            this.physics.add.collider(this.bob, [staticDecorHanger, this._neighbourGroup]) 
        this.peiPeiSay("Bring the lanterns to your friends so that they can make a wish!")

        this._sumOfStars = this._neighbourGroup.children.entries.length * this._GAME_ACTION_POINT
        this.board.score.setText(`0/${this._sumOfStars}`)
    }
    takeLantern(){
        if(this._withLantern) return
        const overlaps = this._flyingLanterns.children.entries.filter(f => this.physics.overlapRect(f.x, f.y, f.width, f.height-20, true, false).length !== 0)
        if (overlaps.length !== 1) return
        const f = overlaps[0]
        f.destroy()
        this._withLantern = true
        this.sound.play("grabbed-object")
    }
    onSpace(){
        if(!this._withLantern) return
        const overlaps = this._neighbourGroup.children.entries.filter(f => this.physics.overlapRect(f.x, f.y, f.width, f.height-20, true, false).length !== 0)
        const homieOverlaps = this._happyHomie.children.entries.filter(f => this.physics.overlapRect(f.x, f.y, f.width, f.height-20, true, false).length !== 0)[0]
        if (overlaps.length !== 1) return
        const f = overlaps[0]
        const targetNeighbour = this._normalNeighbor.filter(h => h.name === f.texture.key)[0]
        this.homieSay(targetNeighbour.wish, f.body.center.x, f.body.center.y)
        this.sound.play("speech")
        if(targetNeighbour.done) return
        this.physics.pause()

        this.time.addEvent({ delay: 1000, callback: ()=> {
            this._withLantern = false
            this._happyBob = true
            homieOverlaps.setVisible(true)
            f.setVisible(false)
                this.time.addEvent({ delay: 3000, callback: ()=> {
                this._happyBob = false
                homieOverlaps.setVisible(false)
                f.setVisible(true)
                this.physics.resume()
            }, callbackScope: this })
            this.add.sprite(this.bob.body.left, this.bob.body.top).setOrigin(0,1).play("flying-lantern")
            let result = this._normalNeighbor.filter(i => i.done === false)
            if (result.length === 0) {
                    this.time.addEvent({ delay: 3000, callback: ()=> {
                    this.win(this.board.score.text, this._level.current.index + 1); this.peiPeiSay("Mission Accomplished!")
                }, callbackScope: this })
            }
        }, callbackScope: this })
        this.peiPeiSay("Nice job! You earned a star!")
        let score = this.board.score.text
        this.board.score.setText(`${parseInt(score) + 5}/${this._sumOfStars}`)
        targetNeighbour.done = true
    }
    homieSay(msg, x, y) {
        let text = Utility.make.text(this, 30, 15, msg,  {
            fontSize: "40px"
        }).setResolution(1)
        let w = text.width + 60
        let panel = this.add.graphics()
            .fillStyle(0x070b34, 1)
            .fillRoundedRect(0, 0, w, 80, 20)
        if (this._homieBubble.container) this._homieBubble.container.destroy()
        this._homieBubble.container = this.add.container(x - w/2, y - 200).setDepth(220)
        this._homieBubble.container.width = w
        this._homieBubble.container.height = 80
        this._homieBubble.container.add([panel, text])
        this._homieBubble.started = Date.now()
    }
    updateHomieBubble(){
        let b = this._homieBubble
        if (!b.container) return
        if (Date.now() - b.started > 8000) {
            b.container.destroy()
            b.container = null
        }
    }
    update(time, delta){
        super.update(time, delta)
        this.takeLantern()
        this.updateHomieBubble()
    }
    play(direction) {
        let d = (this._withLantern) ? {...direction, animation: `${direction.animation}-with-lantern`} : direction;
        if(this._happyBob) {
            if(d.animation.includes("right")){
                this.bob.play("happy-bob-right")
                return
            }
            this.bob.play("happy-bob-left")
            return
        }
        super.play(d)
    }
}